module.exports = __webpack_public_path__ + "static/media/acacia-logo.0ee22655.png";